import React from "react";
import PrivateLayout from "components/PrivateLayout";
import { Link } from "react-router-dom";
import { NonIdealState } from "@blueprintjs/core";

function EntityMasterMovedScreen() {
  return (
    <PrivateLayout>
      <NonIdealState
        icon="info-sign"
        title="Entity Master moved"
        description="Entity Master functionality has been moved to the PRISM application."
        action={<Link to="/">Back to home</Link>}
      />
    </PrivateLayout>
  );
}

export default EntityMasterMovedScreen;
